<template>
	<div>
		<!-- 混动时代 -->
		<div class="home">
			<!-- <a href="https://www.pcauto.com.cn/hundong?ad=19305" target="_blank">
			<img src="https://www1.pcauto.com.cn/20230302/hybrid_age/1280-800.jpeg" width="620" alt="混动时代">
		</a> -->

		<search-config :keyword="keyword"/>
		<!-- 混动时代 -->
		</div>
    <div class="home">
		
		<common v-if="currentTab.title == 'auto_index'"></common>
		<article-page  v-if="currentTab.title == 'auto_cms'"></article-page>
		<bbs-page v-if="currentTab.title == 'auto_bbs'"></bbs-page>
		<video-page v-if="currentTab.title == 'auto_video'"></video-page>
		<baike-page v-if="currentTab.title == 'auto_baike'"></baike-page>
		<picture-page v-if="currentTab.title == 'picture'"></picture-page>
		<expert-page v-if="currentTab.title == 'auto_hj'"></expert-page>
    </div>
</div>
</template>

<script>
import Common from '../components/commons/commonPage/Common' 
import SearchConfig from '../components/commons/searchConfig/index' 
import ArticlePage from '../components/commons/articlePage/Common'
import BbsPage from '../components/commons/bbsPage/Common'
import VideoPage from '../components/commons/videoPage/Common'
import BaikePage from '../components/commons/baikePage/Common'
import PicturePage from '../components/commons/picturePage/Common'
import ExpertPage from '../components/commons/expertPage/Common'
export default {  
  components: { Common, ArticlePage, BbsPage, VideoPage, BaikePage, PicturePage, ExpertPage,SearchConfig },
    name: 'Home',
	data() {
		return {
			currentTab: {}, // 当前的tab栏
            qType: 0, //搜索的结果类型
            commonId: '', //返回结果的id
			keyword:''
		}
	},
    methods: {
        //接收changeTab事件对应页面分别请求数据
        onChangTab() {
            this.$EventBus.$on('changeTab',(o) => {this.currentTab = o})
        },
    },
	mounted() {
		this.keyword = this.$global.q
		this.onChangTab()
        this.currentTab = this.$global.tab
        document.title = `${this.$global.tab.text} : ${this.$global.q}`
	},
    beforeDestroy() {
        this.$EventBus.$off('changeTab')
    }
}
</script>

<style lang="scss" scoped>
.home {
	max-width: 1000px;
	margin: 0 auto;
	display: flex;
	justify-content: space-between;
}
</style>
